import { render, staticRenderFns } from "./CardHead.vue?vue&type=template&id=df0f807a&"
import script from "./CardHead.vue?vue&type=script&lang=js&"
export * from "./CardHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports